import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import getTimestamp from 'utils/getTimestamp';

import ConfirmationDialogWrapper from 'components/Booking-new/modules/Steps/Time/Variants/components/ConfirmationDialog/ConfirmationDialogWrapper';
import {
  StyledDateTimeContainer,
  Date,
  TimesContainer,
  TimeButton,
} from 'components/Booking-new/modules/Steps/Time/Variants/components/Dates/styles';
import { formatDate, formatTime } from 'components/Booking-new/utils/helpers/bookingMomentHelpers';

const Dates = ({
  date,
  times,
  noDates,
  selectedTime,
  handleTimeSelect,
  useConfirmation,
  confirmationDialogProps,
  location,
  handleGTMAppointmentTimeSelectedEvent,
  showTimeSlots,
}) => {
  const handleTimeButton = time => {
    const timestamp = getTimestamp(date, time);
    return (
      <ConfirmationDialogWrapper
        key={timestamp}
        ButtonComponent={TimeButton}
        buttonProps={{
          active: timestamp === selectedTime,
          onClick: () => handleTimeSelect(timestamp, location),
          'data-test': 'booking-choose-time-slot',
          'aria-label': 'Booking time',
          text: formatTime(time),
        }}
        dialogProps={{
          ...confirmationDialogProps,
          date,
          time,
        }}
        useConfirmation={useConfirmation}
        timestamp={timestamp}
        location={location}
        handleGTMAppointmentTimeSelectedEvent={handleGTMAppointmentTimeSelectedEvent}
        showTimeSlots={showTimeSlots}
      />
    );
  };

  return (
    <StyledDateTimeContainer key={date}>
      <Date variant="DS_copyMediumBold" component="h3" data-test="booking-choose-time-date-title">
        {formatDate(date)}
      </Date>

      {times.length === 0 ? (
        <Typography variant="DS_copyMediumRegular" component="p">
          {noDates}
        </Typography>
      ) : (
        <TimesContainer data-test="booking-choose-time-date-container">{times.map(handleTimeButton)}</TimesContainer>
      )}
    </StyledDateTimeContainer>
  );
};

export default Dates;

Dates.defaultProps = {
  noDates: 'There are no dates available',
};

Dates.propTypes = {
  date: PropTypes.string,
  times: PropTypes.array,
  selectedTime: PropTypes.string,
  useConfirmation: PropTypes.bool,
  confirmationDialogProps: PropTypes.shape({
    location: PropTypes.object,
    cancelButtonLabel: PropTypes.string,
    confirmButtonLabel: PropTypes.string,
  }).isRequired,
  handleTimeSelect: PropTypes.func,
};
